module.exports = __webpack_public_path__ + "static/pandajumperhamper-e52289fa582e1a569c8785833756c170.jpeg";